module.exports = __webpack_public_path__ + "static/media/pci.68f14bc9.svg";